import React from 'react'
import StepOne from './Payment/StepOne'
import StepThree from './Payment/StepThree'
import StepTwo from './Payment/StepTwo'
import MultiStep from 'react-multistep'


function Payment() {
    const steps = [
        { title: 'Select Property', component: <StepOne /> },
        { title: 'Details', component: <StepTwo /> },
        { title: 'Payment', component: <StepThree /> }

    ]
    // custom styles
    const prevStyle = { background: '#020246' }
    const nextStyle = { background: '#020246' }
    return (
        <>

            <div className='container py-5'>
                <div class="payment-box">
                    <div class="payment-title text-center">
                        <h2 className='mb-3'>Payment</h2>
                        <p>Please complete the security form to continue</p>
                    </div>

                    <div class="max-650 mult-btn">
                    <MultiStep activeStep={0} steps={steps} />
</div>
                </div>
            </div>
        </>
    )
}

export default Payment